module.exports = __webpack_public_path__ + "img/2-1.f40369b6.png";